/** @format */

import axios from '@/plugins/axios';
import { setFormDataDocuments, setFormDataAvatar } from '@/utils/person';
import { snackBarError, snackBarSuccess } from '@/utils/snackbar';
import { getUser } from '@/plugins/auth';

const actions = {
	async setTypeDocument({ commit }, payload) {
		try {
			const { data } = await axios(`/persons/${payload._id}/typeDocument`, {
				method: 'put',
				data: payload.typeDocument,
			});
			commit('setPersons', data.person);
			snackBarSuccess(data.message)(commit);
		} catch (error) {
			snackBarError(error)(commit);
		}
	},
	async handlerRequest({ commit }, payload) {
		try {
			const { data } = await axios(`/persons/${payload._id}/handler-request`, {
				method: 'put',
				data: payload,
			});
			commit('setPerson', data.person);
			snackBarSuccess(data.message)(commit);
			return data.person;
		} catch (error) {
			snackBarError(error)(commit);
		}
	},
	async setEditable({ commit }, editable) {
		try {
			const { data } = await axios(`/persons/editable/${editable}`, {
				method: 'patch',
			});
			commit('setPersons', data.persons);
			snackBarSuccess(data.message)(commit);
		} catch (error) {
			snackBarError(error)(commit);
		}
	},
	async startPhoneConfirmation({ commit }, personId) {
		try {
			const { data } = await axios(`/persons/${personId}/actions/start-phone-confirmation`, {
				method: 'patch',
			});
			commit('setPersons', data.person);
			snackBarSuccess(data.message)(commit);
			return data.person;
		} catch (error) {
			snackBarError(error)(commit);
		}
	},
	async unlinkInvite({ commit }, id) {
		try {
			const { data } = await axios(`/person/${id}/unlink-invite`, {
				method: 'patch',
			});
			if (getUser().role == 'person') commit('setPerson', data.person);
			snackBarSuccess(data.message)(commit);
		} catch (error) {
			snackBarError(error)(commit);
		}
	},
	async getPerson({ commit }, id) {
		try {
			const { data } = await axios(`/person/${id}`, { method: 'get' });
			const { person } = data;
			commit('setPerson', person);
			commit('setNotified', person.conversation);
			return data.person;
		} catch (error) {
			snackBarError(error)(commit);
		}
	},
	async getPersonsByAdmin({ commit }) {
		try {
			const { data } = await axios(`/persons`, {
				method: 'get',
			});
			commit('setPersons', data.persons);
		} catch (error) {
			commit('setPersons', []);
			snackBarError(error)(commit);
		}
	},
	async getPersonsInPlace({ commit }, payload) {
		try {
			const { data } = await axios(
				`/persons/personsInPlaceAndLodgings/${payload.placeId}/${payload.toggleConfigMarksPerDay}`,
				{
					method: 'get',
				}
			);
			return data.persons;
		} catch (error) {
			snackBarError(error)(commit);
		}
	},
	async getPersonsByUser({ commit }, id) {
		try {
			const { data } = await axios(`/persons/user/${id}`, { method: 'get' });
			commit('setPersonsByUser', data.persons);
			return data.persons;
		} catch (error) {
			commit('setPersonsByUser', []);
			snackBarError(error)(commit);
		}
	},
	async createPerson({ commit }, payload) {
		try {
			const { data } = await axios(`/persons/create`, {
				method: 'post',
				data: payload,
			});
			commit('setPersons', data.person);
			snackBarSuccess(data.message)(commit);
			return data.person;
		} catch (error) {
			snackBarError(error)(commit);
		}
	},
	async putPerson({ commit }, payload) {
		try {
			payload.editable = payload.editable ? 'editable' : '';
			delete payload.__v;
			//Eliminado salary si es null o undefined
			if (!payload.salary) {
				payload.salary = '';
			}
			const { data } = await axios(`/person/${payload._id}`, {
				method: 'put',
				data: payload,
			});
			const { person, message } = data;
			const role = getUser().role;
			if (role == 'admin' || role == 'superUser') commit('setPersons', person);
			else commit('setPerson', person);
			snackBarSuccess(message)(commit);
			return person;
		} catch (error) {
			snackBarError(error)(commit);
		}
	},
	async upload({ commit }, payload) {
		try {
			const { data } = await axios(`/persons/${payload._id}/upload`, {
				method: 'put',
				data: setFormDataDocuments(payload),
			});
			snackBarSuccess(data.message)(commit);
			return data.person;
		} catch (error) {
			snackBarError(error)(commit);
		}
	},
	async createPersonCSV({ commit }, { payload }) {
		try {
			const { data } = await axios(`/person/create/csv`, {
				method: 'post',
				data: payload,
			});
			const { persons, message, errors } = data;
			commit('setNewPersons', persons);
			snackBarSuccess(message)(commit);
			return errors;
		} catch (error) {
			const { notCreatedPersons, errors } = error.response.data;
			snackBarError(error)(commit);
			return { notCreatedPersons, errors };
		}
	},
	async putAvatar({ commit }, payload) {
		try {
			const { data } = await axios(`/persons/${payload._id}/avatar`, {
				method: 'put',
				data: setFormDataAvatar(payload),
			});
			const { person, message } = data;
			commit('setPerson', person);
			snackBarSuccess(message)(commit);
			return person;
		} catch (error) {
			snackBarError(error)(commit);
		}
	},
	async deleteAllPersons({ commit }) {
		try {
			const { data } = await axios(`/persons/delete/all`, { method: 'delete' });
			return data;
		} catch (error) {
			snackBarError(error)(commit);
		}
	},
	async deletePerson({ commit }, id) {
		try {
			const { data } = await axios(`/persons/${id}`, { method: 'delete' });
			snackBarSuccess(data.message)(commit);
			return data;
		} catch (error) {
			snackBarError(error)(commit);
		}
	},
	async deleteDocument({ commit }, { id, index }) {
		try {
			const { data } = await axios(`/persons/${id}/documents/${index}`, {
				method: 'patch',
			});
			commit('setPersons', data.person);
			snackBarSuccess(data.message)(commit);
		} catch (error) {
			snackBarError(error)(commit);
		}
	},
	async removeDocument({ commit }, payload) {
		try {
			const { data } = await axios('/persons/remove-documents', {
				method: 'patch',
				data: payload,
			});
			snackBarSuccess(data.message)(commit);
		} catch (error) {
			snackBarError(error)(commit);
		}
	},
	async conversation({ commit }, { id, payload }) {
		try {
			const { data } = await axios(`/person/${id}/conversation`, {
				method: 'put',
				data: payload,
			});

			const { person } = data;
			commit('setPerson', person);
			commit('setNotified', person.conversation);
			return person;
		} catch (error) {
			snackBarError(error)(commit);
		}
	},
	async updateConversation({ commit }, { id, payload }) {
		try {
			const { data } = await axios(`/person/${id}/update-conversation`, {
				method: 'put',
				data: payload,
			});
			const { person } = data;
			commit('setPerson', person);
			commit('setNotified', person.conversation);
			return person;
		} catch (error) {
			snackBarError(error)(commit);
		}
	},
	async newRequest({ commit }, payload) {
		try {
			const { data } = await axios('/person/new-request', {
				method: 'patch',
				data: payload,
			});
			snackBarSuccess(data.message)(commit);
		} catch (error) {
			snackBarError(error)(commit);
		}
	},
	async generateCsvReport(store, companyId) {
		const { data } = await axios(`/persons/${companyId}/reports/csv`, {
			method: 'get',
			responseType: 'arraybuffer',
		});
		return data;
	},
	async generatePdfReport(store, persons) {
		const { data } = await axios(`/persons/reports-pdf`, {
			method: 'post',
			data: { persons },
			responseType: 'arraybuffer',
		});
		return data;
	},
	async convertToUser({ commit }, id) {
		try {
			const { data } = await axios(`/persons/${id}/actions/convert-to-user`, {
				method: 'post',
			});
			commit('setPersons', data.person);
			snackBarSuccess(data.message)(commit);
		} catch (error) {
			snackBarError(error)(commit);
		}
	},
	async unlinkSharedPerson({ commit }, id) {
		try {
			const { data } = await axios(`/persons/${id}/actions/unlink-share`, {
				method: 'patch',
			});
			commit('setPersons', data.persons);
			snackBarSuccess(data.message)(commit);
		} catch (error) {
			snackBarError(error)(commit);
		}
	},
	async setGeolocation({ commit }, payload) {
		try {
			const { data } = await axios(`/person/${payload._id}/geolocation`, {
				method: 'put',
				data: payload.geolocation,
			});
			const { person, message } = data;
			commit('setPerson', person);
			snackBarSuccess(message)(commit);
		} catch (error) {
			snackBarError(error)(commit);
		}
	},
	async uploadPublications({ commit }, payload) {
		try {
			const { data } = await axios(`/person/publications`, {
				method: 'post',
				data: payload,
			});
			const { persons, message } = data;
			commit('setPersons', persons);
			snackBarSuccess(message)(commit);
		} catch (error) {
			snackBarError(error)(commit);
		}
	},
	async deletePublication({ commit }, { personId, id }) {
		try {
			const { data } = await axios(`/person/${personId}/publication/${id}`, {
				method: 'delete',
				data: personId,
			});
			const { person, message } = data;
			commit('setPersons', person);
			snackBarSuccess(message)(commit);
		} catch (error) {
			snackBarError(error)(commit);
		}
	},
	async updatePublication({ commit }, payload) {
		try {
			const { data } = await axios(`/person/publications/${payload.publicationId}`, {
				method: 'put',
				data: payload,
			});
			const { person } = data;
			commit('setPerson', person);
		} catch (error) {
			snackBarError(error)(commit);
		}
	},
};

export default actions;
